module.exports = __webpack_public_path__ + "static/media/pdfLogo.96221021.png";